import wl_select from './wl_select.vue';

wl_select.install = function (Vue) {
    Vue.component(wl_select.name, wl_select);
};

export default wl_select;